import { ComponentType, createContext, useContext, PropsWithChildren } from 'react';
import { MenuProps } from './types';

export type MenuContextState = {
  Menu: ComponentType<React.PropsWithChildren<MenuProps>>;
};

export const MenuContext = createContext<MenuContextState>({ Menu: () => null });

export const useMenuContext = () => useContext(MenuContext);

export const MenuContextProvider = ({
  children,
  ...props
}: PropsWithChildren<MenuContextState>) => (
  <MenuContext.Provider value={props}>{children}</MenuContext.Provider>
);
